export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const SET_NEWSPAPER = "setNewspaper";
export const SET_NEWSPAPERS = "setNewspapers";
export const SET_NEWSLIST = "setNewslist";
export const SET_NEWSINFO = "setNewsinfo";
export const SET_COMMENTS = "setComments";
export const SET_CONFIG = "setConfig";
export const SET_MSG = "setTips";
export const UPDATE_CONFIG = "updateConfig";
export const SET_CAT = "setCat";